import { Button, Grid } from '@mui/material';
import axios from 'axios';
import moment from 'moment';
import React, { useContext, useEffect, useRef, useState } from 'react'
import { useHistory } from 'react-router'
import { NavLink } from 'react-router-dom';
import { authContext } from '../../context/AuthContext';
import Loading from '../helper/Loading';
import PageHeader from '../helper/PageHeader'
import SimpleTable from '../helper/SimpleTable'
import { withTranslation } from 'react-i18next';

const Training = props => {

    const {t} = props;

    const tableCellsCert = [
        { id: 'score', label:  t('TrainingHistoryDetails.Score'), centered: false },
        { id: 'startDate', label:  t('TrainingHistoryDetails.Started'), centered: false },
        { id: 'endDate', label:  t('TrainingHistoryDetails.Finished'), centered: false },
        { id: 'statusView', label: t('TrainingHistoryDetails.Status'), centered: false },
    ];

    const history = useHistory()
    const state = history.location.state
    const mounted = useRef(true)
    const user = useContext(authContext).user

    const [data, setData] = useState(null) // the courseProgress data (an array of each submodule)
    // const [moduleOpen, setModuleOpen] = useState({ open: false, loading: null, info: null }) // the dialog
    // const [allQuizzesPassed, setAllQuizzesPassed] = useState(null) // now this is part of certData (enabled) I think
    const [certData, setCertData] = useState({ enabled: false, data: [], lessThan2: true, max: -1 })

    const trainingType = state.type
    const trainingId = state.trainingId
    const certTestLink = state.certLink
    const parentCourseId = state.id
    const trainingCode = state.serialNum
    const fromView = state.fromView || false

    console.log("Stuff", state, trainingType, certTestLink)

    useEffect(() => {
        async function getInfo() {
            console.log(state);
            // grab the children of the parent and the score for the parent
            const res = await axios.all([
                axios.get('/api/courseProgress/children', {
                    params: {
                        username: user.username,
                        courseID: parentCourseId,
                        trainingId: trainingId
                    }
                }),
                axios.get('/api/test/all', {
                    params: {
                        student_id: user.username,
                        courseId: parentCourseId,
                        trainingId: trainingId,
                        isDisregarded: false
                    }
                })
            ])

            console.log(parentCourseId)

            if (mounted.current) {
                console.log("Printing res", res)
                const data = res[0].data.result
                const certData = res[1].data.tests

                // gets disabled if all quizzes not passed and online
                let certTestEnabled = true

                // if a module is not started, its fields such as status and start date are not included in that modules JSON
                console.log("Data", data, certData)
                data.map(e => {
                    // lastViewed is currently the start date of the most recent record
                    if (e.STARTDATE !== null && e.STARTDATE !== undefined) 
                        e.lastViewed = moment(e.STARTDATE).format('YYYY-MM-DD hh:mm:ss A')

                    // disable certTest if not passed and online and postTestLink exists
                    if (e.STATUS !== "passed" && trainingType === 'Online' && e.postTestLink !== "") 
                        certTestEnabled = false

                    e.actionsDisabled = {
                        // quiz is only disabled if status is incomplete. Completed or Passed leaves quiz enabled
                        // also disable the quiz if there is no quiz required (not postTestLink) (remove the quiz button entirely if so)
                        hasQuiz: !(e.postTestLink === ""),
                        quiz: (e.STATUS === "incomplete" || e.STATUS === undefined || e.postTestLink === "" || e.postTestLink === undefined) ?
                            (trainingType === 'DVD' || trainingType === 'Zoom') ? false : true // if the trainingType is not Online, then quiz is always enabled (irrelevant of status)
                            : false,

                        view: e.STATUS === undefined ? true : false, // for course lecture

                        review: e.highestScore === undefined // for quiz review, disabled if no quiz score


                    }
                    e.label =  e.postTestLink === "" ? e.label + " - no quiz" : e.label;
                    e.statusView =  e.STATUS ? t('lmsStatus.Status', { context: e.STATUS }) : null;

                    console.log(e)
                    return e
                })
                // looks like the above is mutating "data" directly. Wups
                // this is from ViewQuiz. Seems like it is also mutating directly
                const testData = certData.map(e => {

                    // fomatting the time with this causes issues if the millisecond time is larger than a day (wraps back around to the next day, max of 23:59:59)
                    // e.humanTime = moment.utc(e.TOTALTIMEINMILLISECOND).format('HH:mm:ss')
                    if (e.startDate !== null && e.startDate !== undefined) e.startDate = moment(e.startDate).format('YYYY-MM-DD hh:mm:ss A')
                    if (e.endDate !== null && e.endDate !== undefined) e.endDate = moment(e.endDate).format('YYYY-MM-DD hh:mm:ss A')
                    e.statusView =  t('trainingStatus.Status', { context: e.status })
                    e.STATUS = e.status
                    return e
                })

                const maxScore = Math.max(...testData.map(e => e.score))

                setData(data)
                setCertData({ enabled: certTestEnabled, data: testData, lessThan2: certData.length < 2, max: maxScore })
            }
        }

        // if the location state is defined
        if (state !== undefined) getInfo()

        return () => mounted.current = false
    // eslint-disable-next-line 
    }, []) 

    const onGo = (id) => {
        console.log(id)
        const module = data.find(e => e.COURSEID === id)
        console.log(module)
        const hyperlink = module.hyperlink
        const quizSrc = module.postTestLink
        const prevStatus = module.STATUS
        history.push('/lms/' + id, { courseSrc: hyperlink, quizSrc, prevStatus, trainingId, fromView })

    }

    const openInfo = (id) => {
        history.push('/training/' + id, { ...data.find(e => e.COURSEID === id) })
    }

    const goQuiz = (id) => {
        const module = data.find(e => e.COURSEID === id)
        history.push('/lms/' + id + '/quiz', { fromVideo: false, quizSrc: module.postTestLink, trainingId: trainingId,  needAffidative: false })
    }
    const openQuizReview = (id) => {
        const module = data.find(e => e.COURSEID === id);
        let username = user.username;
        history.push('/training/viewQuiz/' + id, { label: module.label, username: username, trainingId: trainingId })
    }

    // const goReview = (id) => {
    //     history.push('/lms/reviewQuiz/' + id, { quizSrc: data.find(e => e.COURSEID === id).postTestLink })
    // }

    const goCert = () => {
        history.push('/lms/' + parentCourseId + '/quiz', { fromVideo: false, quizSrc: certTestLink, trainingId: trainingId, needAffidative: true })
    }

    // const goCertHistory = (id) => {

    // }

    let actionButtons = [
        { icon: "play", label: t('TrainingHistoryDetails.Start')  , action: onGo, delete: false },
        // { icon: "view", label: 'History', action: openInfo, delete: false },
        { icon: "quiz", label: t('TrainingHistoryDetails.TakeQuiz'), action: goQuiz, delete: false, view: "hasQuiz" },
        // { icon: "review", label: 'Quiz  History', action: openQuizReview, delete: false, view: "hasQuiz" },
        // { icon: "review", label: 'Review Quiz', action: goReview, delete: false, view: "hasQuiz" } // old. Originally opened the most recent quiz is articulate to let users click through the questions to see answers

    ];

    if (fromView)
        actionButtons = [
            { icon: "play", label: t('TrainingHistoryDetails.Start'), action: onGo, delete: false },
            { icon: "quiz", label: t('TrainingHistoryDetails.TakeQuiz'), action: goQuiz, delete: false, view: "hasQuiz" },
            // { icon: "view", label: 'History', action: openInfo, delete: false },
            // { icon: "review", label: 'Quiz  History', action: openQuizReview, delete: false },
        ]

    // diplay the course label, completion status, start date, end date, total time
    const tableCells = [
        // { id: 'id', label: 'ID', centered: false },
        { id: 'label', label: t('TrainingHistoryDetails.TrainingModule') , centered: false },
        { id: 'statusView', label: t('TrainingHistoryDetails.Status') , centered: false, hyperlink: openInfo },
        // { id: 'STARTDATE', label: 'Started', centered: false },
        // { id: 'ENDDATE', label: 'Finished', centered: false },

        { id: 'lastViewed', label: t('TrainingHistoryDetails.LastViewed'), centered: false },
        { id: 'highestScore', label: t('TrainingHistoryDetails.HighestScore'), centered: false, hyperlink: openQuizReview },
    ];

    return (
        <>
            {state === undefined ? // if the course id (english /spanish verison) is not there (i.e. manually entered the url instead of navigating from the previous page)
                <h1> {t('TrainingHistoryDetails.Invalid')} </h1> :
                <>
                    <PageHeader title={state ? state.label : "Course"} cancel={history.goBack} />
                    {data === null ? <Loading /> :
                        <>
                            <p> {t('TrainingHistoryDetails.Username')} {user.username}</p>
                            <p> {t('TrainingHistoryDetails.Name')} {user.first_name + ' ' + user.last_name}</p>
                            <p> {t('TrainingHistoryDetails.TrainingType')} {trainingType}</p>
                            {trainingType === 'DVD' && <p> {t('EnterCode.DVDCode')}: {trainingCode}</p>}
                            {trainingType === 'Zoom' && <p> {t('EnterCode.ZoomCode')}: {trainingCode}</p>}

                            {trainingType === 'Online' ? // display a message about how to unlock cert test
                                <p> {t('TrainingHistoryDetails.QuizModulesToBePassed')}  </p> :
                                <p> {t('TrainingHistoryDetails.ReviewPurpose')}  </p>
                            }
                            <p> {t('TrainingHistoryDetails.ClassExpirationInfo')}</p>

                            <SimpleTable
                                data={data}
                                cellKey={"COURSEID"}
                                tableCells={tableCells}
                                actionButtons={actionButtons}
                                actions={true}
                            />

                            <br />
                            <PageHeader title={t('TrainingHistoryDetails.CertificationTest')}  />


                            <Grid
                                container
                                spacing={3}
                                alignItems="center"
                                justifyContent="center"
                            >
                                {
                                    certData.max >= 75 ?
                                        <div style={{ textAlign: "center" }}>
                                            <h1>{t('TrainingHistoryDetails.CertificationTestPassed')} </h1>
                                            <p> {t('TrainingHistoryDetails.CertificationTestPassedInfo')}</p>
                                            <p> {t('TrainingHistoryDetails.MaxScore')}  {certData.max}</p>
                                        </div> :

                                        (!certData.enabled || !certData.lessThan2) ?
                                            <Grid item xs={12}>
                                                <p style={{ textAlign: "center" }}>
                                                    {!certData.lessThan2 ? <> {t('TrainingHistoryDetails.OnlineTestMax')} <NavLink to='/classes' > {t('TrainingHistoryDetails.SignUpInPerson')} </NavLink>.</> :
                                                        t('TrainingHistoryDetails.BeforeCertification') }
                                                </p>
                                            </Grid>

                                            :

                                            certData.lessThan2 ? // show take test if less than 2 tests taken
                                                <Grid item xs={4}>
                                                    <Button disabled={!certData.enabled} variant="contained" color="primary" onClick={goCert} fullWidth> {t('TrainingHistoryDetails.TakeTest')} </Button>
                                                </Grid>
                                                :
                                                <></>
                                }

                            </Grid>

                            {certData.data.length > 0 &&
                                <>
                                    <PageHeader title={t('TrainingHistoryDetails.CertificationTestHistory')} />
                                    <p> {t('TrainingHistoryDetails.NumberOfSessions')}  {certData.data.length}</p>
                                    <p> {t('TrainingHistoryDetails.BestScore')}  {certData.max}</p>
                                    <SimpleTable
                                        data={certData.data}
                                        cellKey={"ID"}
                                        tableCells={tableCellsCert}
                                    />
                                </>
                            }

                        </>
                    }



                </>
            }
        </>
    )
}

export default withTranslation()(Training)